import { CERTS, TRAINING } from "../../data/content";
import { GraduationCap } from "lucide-react";
import { Reveal } from "./Reveal";

export const Certifications = () => (
  <section className="section" aria-labelledby="certs-heading">
    <div className="container">
      <div className="section-header" style={{ textAlign: "center" }}>
        <div className="section-label">Credentials</div>
        <h2 className="section-heading" id="certs-heading">Professional <em>Certifications</em></h2>
      </div>
      <div className="certs-grid">
        {CERTS.map((c, i) => {
          const Icon = c.icon;
          return (
            <Reveal className="cert-card" key={c.name} delay={(i % 3) * 70}>
              <div className="cert-icon"><Icon size={24} /></div>
              <div>
                <div className="cert-name">{c.name}</div>
                <div className="cert-issuer">{c.issuer}</div>
              </div>
            </Reveal>
          );
        })}
      </div>

      <div className="training-block">
        <h3 className="training-title">Completed <em>Training Courses</em></h3>
        <p className="training-sub">Postgraduate diplomas and certificate courses across procurement, resilience, development management, and gender.</p>
        <div className="training-grid">
          {TRAINING.map((t, i) => (
            <Reveal className="training-item" key={t.name} delay={(i % 3) * 60} data-testid={`training-${i}`}>
              <GraduationCap size={18} className="training-icon" />
              <div>
                <div className="training-name">{t.name}</div>
                <div className="training-issuer">{t.issuer}</div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
